<template lang="pug">
  div
    .header__mobile-menu-btn(v-tap="show")
    .header__mobile-overlay(
      :class="{ 'header__mobile-overlay_active': active }"
      v-tap="hide"
    )
    .hidden-menu(:class="{ 'hidden-menu_active': active }")
      .hidden-menu__inner(ref="menuInner")
        .hidden-menu__content
          RouterLink.hidden-menu__item(
            @click="_txq.push(['track', 'navigation'])"
            v-tap="hide"
            v-for="item in menu"
            v-show="item.title"
            :key="item.title"
            :to="{query: $route.query, ...item.to }"
          ) {{ item.title }}
          .hidden-menu__item(
            v-tap="showModal"
            @click="_txq.push(['track', 'navigation'])"
          )
            | {{ $t('header.feedback') }}
          RouterLink.hidden-menu__item.hidden-menu__item_fighter(
            v-tap="hide"
            :to="{ name: 'fighter', params: { code: 'khabib-nurmagomedov' } }"
          )
            div(v-html="$t('header.ambassador')")
            svg(
              xmlns="http://www.w3.org/2000/svg"
              width="30" height="34"
              viewBox="0 0 20 23"
            )
              path(fill-rule="evenodd" d="M16.81 4.139A10.474 10.474 0 0 1 1.992 18.948l1.071-1.072A10.474 10.474 0 0 1 17.88 3.069z" clip-rule="evenodd")
              path(id="arr" stroke="#002CFF" d="m8.134 6.68 4.035 4.036-4.035 4.036")
</template>

<script>
import { mapGetters } from 'vuex'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default {
  name: 'HeaderTopMobileMenu',
  data: () => ({
    active: false
  }),
  computed: {
    ...mapGetters('main', ['menu'])
  },
  watch: {
    active (value) {
      if (value) {
        disableBodyScroll(this.$refs.menuInner)
      } else {
        enableBodyScroll(this.$refs.menuInner)
      }
    }
  },
  methods: {
    show () {
      this.active = true
    },
    hide () {
      this.active = false
    },
    showModal () {
      this.$modal.show('ModalFeedback')
    }
  }
}
</script>
